import { ActionTypes } from "@/App/constants/actionTypes";
import { TransmissionTypes } from "@/types";

type SubmitTransmissionManualAction = {
  type: typeof ActionTypes.SUBMIT_TRANSMISSION_MANUAL;
  payload: TransmissionTypes.TransmissionData;
  formName: string;
};

export const submitTransmissionManual = (payload: TransmissionTypes.TransmissionData, formName: string): SubmitTransmissionManualAction => {
  return {
    type: ActionTypes.SUBMIT_TRANSMISSION_MANUAL,
    payload,
    formName,
  };
};

type SubmitTransmissionManualResultAction = {
  type: typeof ActionTypes.TRANSMISSION_MANUAL_RESULT;
  payload: TransmissionTypes.ManualClaimRawResponseData;
};

export const submitTransmissionManualResult = (data: TransmissionTypes.ManualClaimRawResponseData): SubmitTransmissionManualResultAction => {
  return {
    type: ActionTypes.TRANSMISSION_MANUAL_RESULT,
    payload: data,
  };
};

export type TransmissionManualActions = SubmitTransmissionManualAction | SubmitTransmissionManualResultAction;
